export default {
  navBar: {
    height: '3rem',
  },
  sideBar: {
    width: '20rem',
  }
}
